<paper-segmented-control
  data-testid="cmdk-scope-chips"
  [options]="options()"
  [value]="value()"
  [ariaLabel]="ariaLabel()"
  (valueChange)="onChange($event)" />
